var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThanksImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 377,
    height: 230,
    viewBox: "0 0 377 230",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5404",
    "data-name": "Group 5404",
    transform: "translate(-1249 -300)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2922",
    "data-name": "Ellipse 2922",
    cx: 115,
    cy: 115,
    r: 115,
    transform: "translate(1335 300)",
    fill: "#edfaf2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5402",
    "data-name": "Group 5402"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6234",
    "data-name": "Rectangle 6234",
    width: 86,
    height: 20,
    rx: 10,
    transform: "translate(1277 355)",
    fill: "#edfaf2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6237",
    "data-name": "Rectangle 6237",
    width: 86,
    height: 20,
    rx: 10,
    transform: "translate(1278 375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6238",
    "data-name": "Rectangle 6238",
    width: 86,
    height: 20,
    rx: 10,
    transform: "translate(1261 415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6235",
    "data-name": "Rectangle 6235",
    width: 86,
    height: 20,
    rx: 10,
    transform: "translate(1300 395)",
    fill: "#edfaf2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6236",
    "data-name": "Rectangle 6236",
    width: 110,
    height: 20,
    rx: 10,
    transform: "translate(1249 435)",
    fill: "#edfaf2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5403",
    "data-name": "Group 5403",
    transform: "translate(1516 410)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6234-2",
    "data-name": "Rectangle 6234",
    width: 86,
    height: 20,
    rx: 10,
    transform: "translate(13)",
    fill: "#edfaf2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6237-2",
    "data-name": "Rectangle 6237",
    width: 86,
    height: 20,
    rx: 10,
    transform: "translate(24 20)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6238-2",
    "data-name": "Rectangle 6238",
    width: 86,
    height: 20,
    rx: 10,
    transform: "translate(4 60)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6235-2",
    "data-name": "Rectangle 6235",
    width: 86,
    height: 20,
    rx: 10,
    transform: "translate(-11 40)",
    fill: "#edfaf2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6236-2",
    "data-name": "Rectangle 6236",
    width: 110,
    height: 20,
    rx: 10,
    transform: "translate(-18 80)",
    fill: "#edfaf2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5334",
    "data-name": "Group 5334",
    transform: "translate(234.289 165.57)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4293",
    "data-name": "Rectangle 4293",
    width: 53.187,
    height: 18.616,
    rx: 2,
    transform: "translate(1165.776 198.353)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M-11462.554,2219.89l9.1,9.411,40.576-41.193-9.1-8.331Z",
    transform: "translate(12685.369 -1936.809)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2789",
    "data-name": "Ellipse 2789",
    cx: 3.989,
    cy: 3.989,
    r: 3.989,
    transform: "translate(1165.776 227.606)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2790",
    "data-name": "Ellipse 2790",
    cx: 3.989,
    cy: 3.989,
    r: 3.989,
    transform: "translate(1165.776 248.881)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2791",
    "data-name": "Ellipse 2791",
    cx: 3.989,
    cy: 3.989,
    r: 3.989,
    transform: "translate(1165.776 267.497)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M126.022,52.689a8.106,8.106,0,0,0-11.474,0l-4.053,4.053h0L97.452,69.785V30.4a1.958,1.958,0,0,0-.053-.259,1.851,1.851,0,0,0-.049-.251,1.994,1.994,0,0,0-.49-.92L68.489.6A1.994,1.994,0,0,0,67.573.1a1.832,1.832,0,0,0-.247-.049A1.961,1.961,0,0,0,67.058,0H10.316A10.133,10.133,0,0,0,.183,10.133V119.565A10.133,10.133,0,0,0,10.316,129.7H87.323a10.133,10.133,0,0,0,10.133-10.133V92.717l24.5-24.5h0l4.053-4.053a8.106,8.106,0,0,0,.008-11.47ZM69.085,6.919,90.537,28.371H75.164a6.08,6.08,0,0,1-6.08-6.08ZM67.127,28.371H18.422A2.027,2.027,0,0,1,16.4,26.345V18.239a2.027,2.027,0,0,1,2.027-2.027h46.61v6.08a10.035,10.035,0,0,0,2.1,6.08Zm26.292,91.193a6.08,6.08,0,0,1-6.08,6.08H10.332a6.08,6.08,0,0,1-6.08-6.08V10.133a6.08,6.08,0,0,1,6.063-6.08H65.032v8.106H18.422a6.08,6.08,0,0,0-6.08,6.08v8.106a6.08,6.08,0,0,0,6.08,6.08H93.4V73.842L70.134,97.111a1.926,1.926,0,0,0-.235.357c-.041.065-.109.1-.142.17L64.026,109.1a1.994,1.994,0,0,0,.276,2.136l-2.521,2.545a2.027,2.027,0,1,0,2.882,2.837l2.452-2.48.154.154a2.026,2.026,0,0,0,2.339.381l11.462-5.735c.069-.032.105-.1.17-.142a1.926,1.926,0,0,0,.357-.235L93.4,96.758Zm-21.278-17.6,4.62,4.62-7.64,3.822-.547-.551v-.024H68.55l-.211-.211ZM94.027,90.44h0L80.2,104.264l-5.776-5.719,37.5-37.5,5.731,5.731Zm29.154-29.154-2.626,2.626-5.735-5.735,2.626-2.626a4.055,4.055,0,1,1,5.735,5.735ZM34.634,64.849H83.27a2.027,2.027,0,1,0,0-4.053H34.634a2.027,2.027,0,0,0,0,4.053Zm0-12.159H83.27a2.027,2.027,0,0,0,0-4.053H34.634a2.027,2.027,0,0,0,0,4.053ZM54.9,113.181a7.215,7.215,0,0,1-4.365-1.333,11.847,11.847,0,0,0-12.9,0,7.215,7.215,0,0,1-4.365,1.333,7.206,7.206,0,0,1-4.353-1.317,11.154,11.154,0,0,0-6.44-1.913,2.027,2.027,0,1,0,0,4.053,7.206,7.206,0,0,1,4.357,1.333,11.154,11.154,0,0,0,6.44,1.913,11.191,11.191,0,0,0,6.448-1.909,7.806,7.806,0,0,1,8.726,0,11.191,11.191,0,0,0,6.448,1.909,2.027,2.027,0,0,0,0-4.053Zm-20.265-68.6H83.27a2.027,2.027,0,1,0,0-4.053H34.634a2.027,2.027,0,0,0,0,4.053Zm0,28.371H83.27a2.027,2.027,0,0,0,0-4.053H34.634a2.027,2.027,0,0,0,0,4.053Zm-16.212,0a6.08,6.08,0,1,0-6.08-6.08,6.08,6.08,0,0,0,6.08,6.08Zm0-8.106A2.027,2.027,0,1,1,16.4,66.875a2.027,2.027,0,0,1,2.027-2.027ZM24.5,87.14a6.08,6.08,0,1,0-6.08,6.08,6.08,6.08,0,0,0,6.08-6.08Zm-6.08,2.027a2.027,2.027,0,1,1,2.027-2.027,2.027,2.027,0,0,1-2.027,2.027Zm16.212-4.053H67.058a2.027,2.027,0,1,0,0-4.053H34.634a2.027,2.027,0,0,0,0,4.053ZM18.422,52.689a6.08,6.08,0,1,0-6.08-6.08,6.08,6.08,0,0,0,6.08,6.08Zm0-8.106A2.027,2.027,0,1,1,16.4,46.61a2.027,2.027,0,0,1,2.027-2.027ZM34.634,93.22H67.058a2.027,2.027,0,1,0,0-4.053H34.634a2.027,2.027,0,0,0,0,4.053Z",
    transform: "translate(1151.528 184.966)",
    fill: "#3d4977"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanksImg);
export default __webpack_public_path__ + "static/media/thanks_img.32015c6214a4699144b19e60a3a16357.svg";
export { ForwardRef as ReactComponent };